const ua = typeof navigator !== 'undefined' ? navigator.userAgent || '' : ''

/** `mobile/app` WebView (UA `HumindAndroid/*`) */
export const isAndroidApp = /HumindAndroid/i.test(ua)

/** 앱 변형: `clinical`(치유사·환자) | `management`(운영) | null(웹·구버전 앱) */
export const androidAppAudience = isAndroidApp
  ? (ua.match(/HumindAudience\/(clinical|management)/i)?.[1]?.toLowerCase() ?? null)
  : null

const AUDIENCE_START_PATH = { clinical: '/agent', management: '/management' }

export const androidAppStartPath = androidAppAudience
  ? AUDIENCE_START_PATH[androidAppAudience]
  : null

function appBridge() {
  return typeof window !== 'undefined' ? window.HumindAndroid : null
}

/** 앱 네이티브 백그라운드 알림용 로그인 토큰 전달 — 구버전 앱(메서드 없음)·웹은 무시 */
export function syncAppSession(auth) {
  const bridge = appBridge()
  try {
    if (auth?.token) bridge?.setSession?.(String(auth.token), String(auth.user?.role ?? ''))
    else bridge?.clearSession?.()
  } catch {
    /* ignore */
  }
}

/** WebSocket으로 받은 알림을 폰 시스템 알림으로(갤럭시 워치로도 전달됨) */
export function notifyApp(notification) {
  const bridge = appBridge()
  if (!bridge?.notify || !notification) return
  try {
    bridge.notify(Number(notification.id) || 0, String(notification.title ?? ''), String(notification.body ?? ''))
  } catch {
    /* ignore */
  }
}

export const APP_DOWNLOADS = Object.freeze({
  clinical: { href: '/downloads/humind-clinical.apk', label: '임상용 Android 앱 다운로드' },
  management: { href: '/downloads/humind-management.apk', label: '운영용 Android 앱 다운로드' },
})
